import React from 'react';
import BilingualField from '@/components/BilingualField';

export function metadataText(row,key,lang) {
  return row?.text_translations?.[key]?.[lang]?.trim() || row?.[key] || '';
}
export default function MetadataLanguageField({row,field,onChange,originalLanguage='it',...props}) {
  const versions={ [originalLanguage]:row[field] || '', ...(row.text_translations?.[field] || {}) };
  return <BilingualField {...props} value={versions} originalLanguage={originalLanguage} onChange={next=>onChange({[field]:next[originalLanguage] || '',text_translations:{...(row.text_translations || {}),[field]:next}})} />;
}
